import { SiInstagram, SiYoutube, SiTiktok, SiLinkedin } from "react-icons/si";
import { FaXTwitter, FaGlobe } from "react-icons/fa6";
import type { IconType } from "react-icons";

export interface SocialPlatform {
  key: string;
  label: string;
  icon: IconType;
  placeholder: string;
  extractHandle: (url: string) => string;
}

function extractPathSegment(url: string, prefix?: string): string {
  try {
    const path = new URL(url).pathname.replace(/\/$/, "");
    const segments = path.split("/").filter(Boolean);
    if (prefix) {
      const idx = segments.indexOf(prefix);
      if (idx >= 0 && segments[idx + 1]) return segments[idx + 1];
    }
    const last = segments[segments.length - 1];
    return last ? `@${last.replace(/^@/, "")}` : url;
  } catch {
    return url;
  }
}

function extractDomain(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export const SOCIAL_PLATFORMS: SocialPlatform[] = [
  {
    key: "instagram",
    label: "Instagram",
    icon: SiInstagram,
    placeholder: "https://instagram.com/username",
    extractHandle: extractPathSegment,
  },
  {
    key: "youtube",
    label: "YouTube",
    icon: SiYoutube,
    placeholder: "https://youtube.com/@channel",
    extractHandle: extractPathSegment,
  },
  {
    key: "tiktok",
    label: "TikTok",
    icon: SiTiktok,
    placeholder: "https://tiktok.com/@username",
    extractHandle: extractPathSegment,
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    icon: SiLinkedin,
    placeholder: "https://linkedin.com/in/username",
    extractHandle: (url) => extractPathSegment(url, "in"),
  },
  {
    key: "twitter",
    label: "X / Twitter",
    icon: FaXTwitter,
    placeholder: "https://x.com/username",
    extractHandle: extractPathSegment,
  },
  {
    key: "website",
    label: "Website",
    icon: FaGlobe,
    placeholder: "https://example.com",
    extractHandle: extractDomain,
  },
];

export function getPlatformByKey(key: string): SocialPlatform | undefined {
  return SOCIAL_PLATFORMS.find((p) => p.key === key);
}
